import { useSummaryData } from "@pages/status-page/hooks/useSummaryData";
import React, { useMemo } from "react";
import { StatusCardListComponent } from "./StatusCardListComponent";
import { getGroupedComponents } from "@pages/status-page/helpers/groupComponents";
import { tw } from "@noones/ui/tw";
import { Skeleton } from "@noones/ui";
import { defineMessages, FormattedMessage } from "react-intl";
import { LanguagePicker } from "@modules/i18n/ui/LanguagePicker";
import { useUnresolvedIncidents } from "@pages/status-page/hooks/useUnresolvedIncidents";
import { IncidentType } from "@store/types";
import {
    compareIncidentByLevel,
    mapApiIncidentToIncident,
} from "@pages/status-page/helpers/incidents";

export const StatusCardsList = () => {
    const { data, isLoading } = useSummaryData();

    const { incidents } = useUnresolvedIncidents<IncidentType>(
        compareIncidentByLevel,
        mapApiIncidentToIncident,
    );

    const components = data?.components;

    const groupedComponents = useMemo(
        () => (components ? getGroupedComponents(components) : undefined),
        [components],
    );

    if (isLoading) {
        return (
            <div className={tw.grid.grid_cols_1.gap_2.md(tw.grid_cols_2)}>
                {Array.from({ length: 6 }).map((_, i) => (
                    <Skeleton key={i} width={300} height={224} />
                ))}
            </div>
        );
    }

    return (
        <div>
            <div className={tw.flex.items_center.justify_between}>
                <h1 className={tw.text_h1.font_semibold.my_0.mb_5}>
                    <FormattedMessage {...messages.title} />
                </h1>

                {incidents.length === 0 && <LanguagePicker />}
            </div>

            {groupedComponents && (
                <div className={tw.grid.grid_cols_1.gap_2.md(tw.grid_cols_2)}>
                    {components &&
                        Object.keys(groupedComponents).map((name: string) => (
                            <StatusCardListComponent
                                key={`${name}-card`}
                                title={name}
                                components={groupedComponents[name]}
                            />
                        ))}
                </div>
            )}
        </div>
    );
};

const messages = defineMessages({
    title: {
        id: "Status.title",
        defaultMessage: "Status",
        description: "title",
    },
});
